export const CARD_SIZES = '274px'
export const HERO_SIZES = '(min-width: 1024px) 700px, 561px'
export const BANNER_SIZES = '100vw'
export const CARD_SRCSET_WIDTH = 548
export const HERO_SRCSET_WIDTH = 1400
export const IMAGE_FALLBACK = '/images/product.png'

export type ResolveProductImageInput = {
  mainPicture?: string
  mainPictureBig?: string
  src?: string
  priority?: boolean
  fallback?: string
  sizes?: string
}

export type ResolvedProductImage = {
  src: string
  srcSet?: string
  sizes: string
  loading: 'eager' | 'lazy'
  fetchPriority: 'high' | 'auto'
}

function normalize(url?: string): string | undefined {
  const trimmed = url?.trim()
  return trimmed ? trimmed : undefined
}

export function resolveProductImage({
  mainPicture,
  mainPictureBig,
  src,
  priority = false,
  fallback = IMAGE_FALLBACK,
  sizes: sizesOverride,
}: ResolveProductImageInput): ResolvedProductImage {
  const main = normalize(mainPicture)
  const big = normalize(mainPictureBig)
  const explicit = normalize(src)
  const isHero = Boolean(priority)

  const slotSrc = isHero
    ? big || main || explicit || fallback
    : main || explicit || big || fallback

  const seen = new Set<string>()
  const candidates: Array<{ url: string; width: number }> = []
  const add = (url: string | undefined, width: number) => {
    if (!url || url === fallback || seen.has(url)) return
    seen.add(url)
    candidates.push({ url, width })
  }

  if (main || big) {
    add(main, CARD_SRCSET_WIDTH)
    add(big, HERO_SRCSET_WIDTH)
  } else if (explicit) {
    add(explicit, isHero ? HERO_SRCSET_WIDTH : CARD_SRCSET_WIDTH)
  }

  const srcSet =
    candidates.length > 0
      ? candidates.map(candidate => `${candidate.url} ${candidate.width}w`).join(', ')
      : undefined

  const sizes =
    sizesOverride ?? (isHero ? HERO_SIZES : main || big ? CARD_SIZES : BANNER_SIZES)

  return {
    src: slotSrc,
    srcSet,
    sizes,
    loading: isHero ? 'eager' : 'lazy',
    fetchPriority: isHero ? 'high' : 'auto',
  }
}
